import elt from "../html/elt";
import injectCSS from "../html/inject-css";
import { registerListener } from "../html/register-listener";

export class CustomColorChip extends HTMLElement {

    colorInput: HTMLInputElement;

    _tint: string = '#FFFFFF';

    constructor() {
        super();
        injectCSS(STYLESHEET);

        this.colorInput =
            elt('input',
                {
                    type: 'color',
                    class: 'form-control',
                });

        registerListener(this.colorInput, 'input', () => {
            this._tint = this.colorInput.value;
        });
    }

    connectedCallback() {
        this.append(
            this.colorInput,
            elt('label', {}, 'Custom')
        );
        this.colorInput.value = this._tint;
    }

    static observedAttributes = ["tint"];

    attributeChangedCallback(name: string, _oldValue: string, newValue: string) {
        switch(name) {
            case "tint":
                this.tint = newValue;
                break;
        }
    }

    get tint(): string {
        return this._tint;
    }

    set tint(value: string) {
        if(this._tint != value) {
            this._tint = value;
            this.update();
        }
    }

    update() {
        if(this._tint) {
            this.colorInput.value = this._tint;
        } else {
            this.colorInput.value = '#FFFFFF';
        }
    }

}
export default CustomColorChip;
window.customElements.define('custom-color-chip', CustomColorChip);

const STYLESHEET = `
custom-color-chip {
    display: block;
    text-align: center;
    padding: 0.5rem;

    cursor: pointer;

    border-color: var(--bs-border-color);
    border-width: var(--bs-border-width);
    border-style: var(--bs-border-style);
    border-radius: var(--bs-border-radius);

    & input {
        width: 3rem;
        height: 3rem;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 0.5rem;

        cursor: pointer;
    }
}
`;
